import { DOCUMENT } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren,
    ViewEncapsulation,
} from '@angular/core';
import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { TrackBy } from 'app/shared/utils/track-by';

export interface FlexDiagnosticsDialogData {
    customerId: number;
    locationId: number;
    locationName: string;
    deviceId?: string;
    canViewRawData: boolean;
}

interface FlexDiagnosticsTab {
    icon: string;
    labelKey: string;
}

@Component({
    selector: 'app-flex-diagnostics-dialog',
    templateUrl: './flex-diagnostics-dialog.component.html',
    styleUrls: ['./flex-diagnostics-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlexDiagnosticsDialogComponent implements OnInit, OnDestroy {
    @ViewChildren('tabButton') private tabButtons: QueryList<ElementRef<HTMLButtonElement>>;

    public selectedTabIndex: number = 0;

    public readonly tabs: FlexDiagnosticsTab[] = [
        { icon: 'show_chart', labelKey: 'DIAGNOSTICS.MONITOR_STATUS' },
        { icon: 'storage', labelKey: 'DIAGNOSTICS.DATA_COLLECT' },
        { icon: 'settings', labelKey: 'DIAGNOSTICS.SENSOR_SUPPORT' },
        { icon: 'waves', labelKey: 'DIAGNOSTICS.WAVEFORMS' },
        { icon: 'assignment', labelKey: 'DIAGNOSTICS.AUDIT_LOG' },
    ];

    public trackByLabelKey: (index: number, item: FlexDiagnosticsTab) => string =
        TrackBy.byUniqueKey<FlexDiagnosticsTab>()('labelKey');

    private readonly scrollLockClass = 'flex-diagnostics-scroll-lock';

    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(MAT_DIALOG_DATA) public readonly data: FlexDiagnosticsDialogData,
        private dialogRef: MatDialogRef<FlexDiagnosticsDialogComponent, void>,
    ) {}

    public ngOnInit(): void {
        this.document.documentElement.classList.add(this.scrollLockClass);
    }

    public ngOnDestroy(): void {
        this.document.documentElement.classList.remove(this.scrollLockClass);
    }

    public selectTab(index: number, focus = false): void {
        this.selectedTabIndex = index;
        if (focus) this.tabButtons.get(index)?.nativeElement.focus();
    }

    public handleTabKeydown(event: KeyboardEvent, index: number): void {
        let nextIndex: number | null = null;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft')
            nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        this.selectTab(nextIndex, true);
    }

    public close(): void {
        this.dialogRef.close();
    }
}
